module.exports = __webpack_public_path__ + "img/ico-inqueue.67fd57c8.svg";